<template>
  <a-descriptions :column="1" :title="title" size="small" class="p-0">
    <a-descriptions-item label="Date">{{ formatDateRange(times.start, times.end) }} </a-descriptions-item
    ><a-descriptions-item label="Start">
      <shift-time-value
        :value="timeRangeToString(times.start, times.end).start ?? '-'"
        :highlight="highlights.start"
        :test-id="`${testIdPrefix}-start`"
        @authorization="$emit('authorization', $event)"
      />
    </a-descriptions-item>
    <a-descriptions-item label="End">
      <shift-time-value
        :value="timeRangeToString(times.start, times.end).end ?? '-'"
        :highlight="highlights.end"
        :test-id="`${testIdPrefix}-end`"
        @authorization="$emit('authorization', $event)"
      />
    </a-descriptions-item>
    <a-descriptions-item label="Duration">
      {{ formatMinutesToHoursAndMinutesDuration(times.duration) ?? '-' }}</a-descriptions-item
    >
    <a-descriptions-item label="1st Meal Break Start">
      <shift-time-value
        :value="timeRangeToString(times.lunch_start, times.lunch_end).start ?? '-'"
        :highlight="highlights.lunch_start"
        :test-id="`${testIdPrefix}-lunch-start`"
        @authorization="$emit('authorization', $event)"
      />
    </a-descriptions-item>
    <a-descriptions-item label="1st Meal Break End">
      <shift-time-value
        :value="timeRangeToString(times.lunch_start, times.lunch_end).end ?? '-'"
        :highlight="highlights.lunch_end"
        :test-id="`${testIdPrefix}-lunch-end`"
        @authorization="$emit('authorization', $event)"
      />
    </a-descriptions-item>
    <a-descriptions-item label="1st Meal Break Duration">
      {{ getFormattedDuration(times.lunch_start, times.lunch_end) }}
    </a-descriptions-item>
    <a-descriptions-item v-if="times.second_meal_status === 'waived'" label="2nd Meal Break">
      Waived
    </a-descriptions-item>
    <a-descriptions-item v-else-if="times.second_meal_status === 'missed'" label="2nd Meal Break">
      <shift-time-value
        value="Missed"
        :highlight="highlights.second_lunch"
        :test-id="`${testIdPrefix}-second-lunch`"
        @authorization="$emit('authorization', $event)"
      />
    </a-descriptions-item>
    <template v-else>
      <a-descriptions-item label="2nd Meal Break Start">
        <shift-time-value
          :value="timeRangeToString(times.second_lunch_start, times.second_lunch_end).start ?? '-'"
          :highlight="highlights.second_lunch_start"
          :test-id="`${testIdPrefix}-second-lunch-start`"
          @authorization="$emit('authorization', $event)"
        />
      </a-descriptions-item>
      <a-descriptions-item label="2nd Meal Break End">
        <shift-time-value
          :value="timeRangeToString(times.second_lunch_start, times.second_lunch_end).end ?? '-'"
          :highlight="highlights.second_lunch_end"
          :test-id="`${testIdPrefix}-second-lunch-end`"
          @authorization="$emit('authorization', $event)"
        />
      </a-descriptions-item>
      <a-descriptions-item label="2nd Meal Break Duration">
        {{ getFormattedDuration(times.second_lunch_start, times.second_lunch_end) }}
      </a-descriptions-item>
    </template>
    <a-descriptions-item label="Work Hours">
      <shift-time-value
        :value="formatMinutesToHoursAndMinutesDuration(times.work_hours) ?? '-'"
        :highlight="highlights.work_hours"
        :test-id="`${testIdPrefix}-work-hours`"
        @authorization="$emit('authorization', $event)"
      />
    </a-descriptions-item>
    <a-descriptions-item label="Pay Hours"
      >{{ formatMinutesToHoursAndMinutesDuration(times.pay_hours) ?? '-' }}
    </a-descriptions-item>
  </a-descriptions>
</template>

<script>
import { Descriptions } from 'ant-design-vue'
import shiftsHelper from '@/helpers/shifts'
import util from '@/util'
import ShiftTimeValue from './form/shift-time-value.vue'

export default {
  components: {
    'a-descriptions': Descriptions,
    'a-descriptions-item': Descriptions.Item,
    'shift-time-value': ShiftTimeValue
  },
  mixins: [shiftsHelper],
  props: {
    title: {
      type: String,
      default: ''
    },
    times: {
      type: Object,
      default: () => ({})
    },
    highlights: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    testIdPrefix() {
      return `shift-view-${this.title.toLowerCase()}`
    }
  },
  methods: {
    formatMinutesToHoursAndMinutesDuration: util.formatMinutesToHoursAndMinutesDuration,
    getFormattedDuration(start, end) {
      if (!start) {
        return ' - '
      }

      const formatted = util.getFormattedDuration(start, end)

      return formatted
    },
    timeRangeToString(start, end) {
      return this.formatTimeRange(start, end)
    }
  }
}
</script>
